var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70.667px",
    height: "118.667px",
    viewBox: "90 11.167 70.667 118.667",
    enableBackground: "new 90 11.167 70.667 118.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "italic",
    d: "M154.125,22.188v4.438c0,2.451-1.986,4.438-4.438,4.438h-7.16l-16.338,79.875h5.749 c2.451,0,4.438,1.986,4.438,4.438v4.438c0,2.451-1.986,4.438-4.438,4.438h-31.063c-2.451,0-4.438-1.986-4.438-4.438v-4.438 c0-2.451,1.987-4.438,4.438-4.438h5.346l16.338-79.875h-3.933c-2.451,0-4.438-1.987-4.438-4.438v-4.438 c0-2.451,1.987-4.438,4.438-4.438h31.063C152.139,17.75,154.125,19.737,154.125,22.188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.c17bb65e1b03b7572e50221a8000f99a.svg";
export { ForwardRef as ReactComponent };